<template>
    <div>
        <h1 class="display-heading mb-3">Appointments Details</h1>

        <ul class="nav nav-tabs nav-tabs-nowrap" id="myTab" role="tablist">
            <li class="nav-item">
                <a class="nav-link active" id="consultation-details-tab" data-toggle="tab" href="#consultationDetails" role="tab">
                    Appointment Details
                </a>
            </li>
            <li v-if="shouldShowCovid19Form" class="nav-item">
                <a class="nav-link" id="consultation-covid19-tab" data-toggle="tab" href="#covid19Questionnaire" role="tab">
                    <span class="text-primary" style="font-weight: bold;">
                        Covid-19 Questionnaire
                    </span>
                </a>
            </li>
        </ul>

        <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="consultationDetails" role="tabpanel">
                <div class="tab-content-wrapper">
                    <div class="card mb-3">
                        <div class="card-body">
                            <appointment-detail
                                participantNameDisplay="Doctor Name"
                                :appointmentId="appointmentDetails.appointmentId"
                                :appointmentDate="appointmentDetails.startTime"
                                :appointmentParticipant="appointmentDetails.targetUserId"
                                :doctorClinicHospitalName="appointmentDetails.doctorHospitalOrClinic"
                                :appointmentStatus="appointmentDetails.appointmentStatusId"
                                :isPatient="true"
                                :isAppointment="true"></appointment-detail>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">Payment Details</div>
                        <div class="card-body">
                            <div v-if="!paymentSummary.isPaid && paymentDetails.companyCreditAutopayError && paymentDetails.companyCreditAutopayErrorMessage"
                                class="card mb-3">
                                <div class="card-body">
                                    {{paymentDetails.companyCreditAutopayErrorMessage}}
                                </div>
                            </div>
                            <payment-detail
                                ref="paymentDetail"
                                :paymentDetails="paymentDetails"
                                :paymentSummary="paymentSummary">
                                <p>
                                    Note: <b>RM{{paymentSummary.paymentAmount.toFixed(2)}}</b> fee allocates a telehealth consultation up to <b>10 minutes only</b>. The cost of medicine will be charged separately if doctor gives you any drug prescription.
                                </p>

                                <button v-if="!paymentSummary.isPaid" class="btn btn-primary btn-primary-insv" @click="showPaymentDisclaimer">Make Payment</button>
                            </payment-detail>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="shouldShowCovid19Form" class="tab-pane fade" id="covid19Questionnaire" role="tabpanel">
                <div class="tab-content-wrapper">
                    <questionnaire-covid19 ref="questionnaireCovid19" :isNew="false"
                        :consultationId="appointmentDetails.consultationId"
                        :patientName="patientName"
                        :patientIcNumber="patientIcNumber">
                    </questionnaire-covid19>
                </div>
            </div>
        </div>

        <popup-modal ref="popupModalConfirmation" :hasCloseButton="false" title="Disclaimer">
           <template slot="content">
                <p>
                    Note: <b>RM{{paymentSummary.paymentAmount.toFixed(2)}}</b> fee allocates a telehealth consultation up to <b>10 minutes only</b>. The cost of medicine will be charged separately if doctor gives you any drug prescription.
                </p>

               <p>Please understand and agree to all of our <a :href="termsAndConditionPatientsUrl" target="_blank">Terms & Conditions</a> before proceeding.</p>
           </template>
           <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="disclaimerProceed">Agreed & Proceed</button>
                <button type="button" class="btn btn-secondary" @click="disclaimerCancel">Cancel</button>
           </template>
        </popup-modal>

        <popup-modal ref="popupPaymentStatus" :hasCloseButton="true" :title="appointmentPaymentStatusTitle">
           <template slot="content">
               <div v-html="appointmentPaymentStatusText">
                </div>
           </template>
           <template slot="footer">
               <button v-if="this.appointmentPaymentStatus===1" @click="moveToDashboardPage" class="btn btn-primary btn-primary-insv">Move to Dashboard Page</button>
               <button v-else @click="dismissPaymentStatus" class="btn btn-primary btn-primary-insv">Okay</button>
           </template>
        </popup-modal>
    </div>
</template>

<script>
import appointmentDetail from '@/components/appointment-detail';
import paymentDetail from '@/components/payment-detail';
import popupModal from '@/components/popup-modal';
import questionnaireCovid19 from '@/components/questionnaires/covid-19';
export default {
    'name': 'UserDoctorAppointmentDetail',
    'components': {
        appointmentDetail,
        paymentDetail,
        popupModal,
        questionnaireCovid19
    },
    'computed': {
        shouldShowCovid19Form () {
            return this.$store.state.shouldShowCovid19Form;
        },
        appointmentId () {
            return this.$route.params.id;
        },
        termsAndConditionPatientsUrl () {
            return this.$store.state.operator.termsAndConditionPatientsUrl;
        },
        patientName () {
            return this.$store.state.user.fullName;
        },
        patientIcNumber () {
            return this.$store.state.user.identityCardNumber;
        },
        appointmentPaymentStatusTitle () {
            switch (this.appointmentPaymentStatus) {
            case 0:
                return 'Payment Failed';
            case 1:
                return 'Payment Successful!';
            case 2:
                return 'Payment Pending.';
            }
        },
        appointmentPaymentStatusText () {
            switch (this.appointmentPaymentStatus) {
            case 0:
                return `<p>Sorry, your payment was unsuccessful.</p>
                <p>Please retry again by making another payment.</p>`;
            case 1:
                if (this.appointmentDetails.isOnDemand) {
                    return `
                    <p>
                        Thank you, your payment has been successfully completed!
                    </p>
                    <p>
                        Move to "Dashboard" page and click "Start Tele-Video" to begin your tele-consultation.
                    </p>`;
                }

                return `
                    <p>
                        Thank you, your payment has been successfully completed!
                    </p>
                    <p>
                        Email will be issued as reminder of your scheduled appointment, 24 hour in advanced.
                    </p>
                    <p>
                        Few minutes before scheduled tele-consultation starts, you may login our system, then go to "Dashboard" page and click "Start Tele-Video"
                    </p>`;
            case 2:
                return '<p>Thank you, your payment status is pending.</p>';
            }
        }
    },
    data () {
        return {
            'paymentDetails': {
                'paymentIdShort': null,
                'completedDate': null,
                'paymentRemarks': null,
                'companyCreditAutopayError': false,
                'companyCreditAutopayErrorMessage': null
            },
            'paymentSummary': {
                'isPaid': false,
                'paymentSummaryId': '',
                'paymentAmount': 0,
                'summaryItems': []
            },
            'appointmentDetails': {
                'appointmentId': '',
                'creatorUserId': '',
                'targetUserId': '',
                'doctorHospitalOrClinic': '',
                'startTime': null,
                'endTime': null,
                'appointmentStatusId': 0,
                'sessionId': '',
                'rejectedUserId': '',
                'rejectedReason': '',
                'isOnDemand': false,
                'consultationId': ''
            },
            'appointmentPaymentStatus': 0
        };
    },
    mounted () {
        if (this.appointmentId) {
            this.axios.get('Appointment/GetUserAppointmentDetails', {
                'params': {
                    'appointmentId': this.appointmentId
                }
            }).then(({
                data
            }) => {
                let appointmentDetailData = data.data;

                this.appointmentDetails.appointmentId = appointmentDetailData.dc ? appointmentDetailData.dc.cis : null;
                this.appointmentDetails.consultationId = appointmentDetailData.dc ? appointmentDetailData.dc.ci : null;
                this.appointmentDetails.creatorUserId = appointmentDetailData.ci;
                this.appointmentDetails.targetUserId = appointmentDetailData.tp ? appointmentDetailData.tp.fn : null;
                this.appointmentDetails.doctorHospitalOrClinic = appointmentDetailData.tp ? appointmentDetailData.tp.dhc : null;
                this.appointmentDetails.startTime = appointmentDetailData.ss;
                this.appointmentDetails.endTime = appointmentDetailData.se;
                this.appointmentDetails.appointmentStatusId = appointmentDetailData.si;
                this.appointmentDetails.sessionId = appointmentDetailData.sid;
                this.appointmentDetails.rejectedUserId = appointmentDetailData.rid;
                this.appointmentDetails.rejectedReason = appointmentDetailData.rj;
                this.appointmentDetails.isOnDemand = appointmentDetailData.iod;

                this.paymentDetails.paymentRemarks = `Payment for Consultation #${this.appointmentDetails.appointmentId}.`;

                this.initializePaymentDetails(appointmentDetailData.ps);
                this.initializePaymentSummary(appointmentDetailData.ps);

                if (this.$route.query && this.$route.query.status) {
                    if (this.$route.query.status === '1') {
                        this.appointmentPaymentStatus = 1;
                    } else if (this.$route.query.status === '6') {
                        this.appointmentPaymentStatus = 2;
                    } else {
                        this.appointmentPaymentStatus = 0;
                    }

                    this.$refs.popupPaymentStatus.show();
                }
            });
        }
    },
    'methods': {
        initializePaymentDetails (paymentSummary) {
            this.paymentDetails.paymentIdShort = paymentSummary.psids;
            this.paymentDetails.completedDate = paymentSummary.cd;

            let companyCreditFailedRelatedCodes = [3, 4, 5];
            this.paymentDetails.companyCreditAutopayError = paymentSummary.ccaf && companyCreditFailedRelatedCodes.includes(paymentSummary.ccafc);

            if (this.paymentDetails.companyCreditAutopayError) {
                switch (paymentSummary.ccafc) {
                case 3:
                    this.paymentDetails.companyCreditAutopayErrorMessage = 'The required payment exceeding the set transaction limit given by your company, please pay either via FPX or credit card. Thereafter you can seek reimbursement from your employer later.';
                    break;
                case 4:
                    this.paymentDetails.companyCreditAutopayErrorMessage = 'The required payment exceeding the set annual limit given by your company, please pay either via FPX or credit card. Thereafter you can seek reimbursement from your employer later.';
                    break;
                case 5:
                    this.paymentDetails.companyCreditAutopayErrorMessage = "Due to your company's internal process, we are unable to approve the payment of this transaction. Please pay either via FPX or credit card. Thereafter you can seek reimbursement from your employer later.";
                    break;
                }
            }
        },
        initializePaymentSummary (paymentSummary) {
            this.paymentSummary.isPaid = paymentSummary.ip;
            this.paymentSummary.paymentSummaryId = paymentSummary.psid;
            this.paymentSummary.paymentAmount = paymentSummary.am;
            this.paymentSummary.summaryItems = paymentSummary.psi.map((item) => ({
                'itemName': item.in,
                'itemType': item.it,
                'itemDescription': item.id,
                'itemPrice': item.ip
            }));
        },
        showPaymentDisclaimer () {
            this.$refs.paymentDetail.validateOffsetWallet().then((isValid) => {
                if (isValid) {
                    this.$refs.popupModalConfirmation.show();
                }
            });
        },
        disclaimerProceed () {
            this.$refs.popupModalConfirmation.hide();
            this.$refs.paymentDetail.payNow();
        },
        disclaimerCancel () {
            this.$refs.popupModalConfirmation.hide();
        },
        dismissPaymentStatus () {
            this.$refs.popupPaymentStatus.hide();
        },
        moveToDashboardPage () {
            this.$refs.popupPaymentStatus.hide().then(() => {
                this.$router.push({
                    'name': 'dashboard-user'
                });
            });
        }
    }

};

</script>

<style>

</style>
